<template>
	<div class="newsletter-container" :class="{editing: !!newsletterStore.editingNewsletterId}">
		<NewsletterSelection
			v-if="!newsletterStore.editingNewsletterId"
			@add-attachment="openAttachmentSheet"
		/>
		<NewsletterEdit
			v-else
			@add-attachment="openAttachmentSheet"
		/>

		<AppBottomSheet
			:force-width="bottomSheetWidth"
			:active="showAttachmentSheet"
			@toggling-popup="toggleAttachmentSheet"
		>
			<ModalHeader
				:title="getString('add_attachment')"
			/>
			<div class="attachment-content">
				<div class="warning-message">
					<div class="warning-icon" v-html="svgStore.get('iconWarning')"></div>
					<div class="warning-info">
						<div class="warning-body">{{ getString('ai_images_info') }}</div>
					</div>
				</div>
				<div class="attachment-dropzone">
					<AppDropzone
						:label="getString('upload_images')"
						:max-bytes="600 * 1024"
						:max-width="1024"
						:max-height="1024"
						:max-files="6"
						:files="attachmentFileUrls"
						@upload-complete="(urls) => handleAttachmentsChanged(urls)"
						@removed-file="(url, urls) => handleAttachmentsChanged(urls)"
					/>
				</div>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import NewsletterSelection from "@/console-new/components/marketing/NewsletterSelection.vue";
import NewsletterEdit from "@/console-new/components/marketing/NewsletterEdit.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppDropzone from "@/shared/components/AppDropzone.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useNewsletterStore} from "@/console-new/stores";
import {useUserStore} from "@/console-new/stores/user.store";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let newsletterStore = useNewsletterStore();
		let userStore = useUserStore();
		let languageStore = useLanguageStore();
		let svgStore = useSvgStore();
		return {
			newsletterStore,
			userStore,
			getString: languageStore.getString,
			svgStore
		};
	},
	name: "NewsletterContainer",
	mixins: [WindowWidth],
	components: {
		NewsletterSelection,
		NewsletterEdit,
		AppBottomSheet,
		AppDropzone,
		ModalHeader
	},
	data() {
		return {
			showAttachmentSheet: false
		};
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		attachmentFileUrls() {
			return this.newsletterStore.attachedImages || [];
		}
	},
	methods: {
		openAttachmentSheet() {
			this.showAttachmentSheet = true;
		},
		toggleAttachmentSheet(isActive) {
			if (!isActive) {
				this.showAttachmentSheet = false;
			}
		},
		handleAttachmentsChanged(files) {
			// files is an array of URL strings from AppDropzone
			// Automatically update the store with the new files
			this.newsletterStore.attachedImages = files;
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.newsletterStore.getBusinessNewsletters();
			}
		}
	},
	mounted() {
		this.newsletterStore.getBusinessNewsletters();
	}
}
</script>

<style scoped lang="scss">
.newsletter-container {

	&.editing {
		height: 100%;
		min-height: 380px;
	}
}

.attachment-content {

	.warning-message {
		padding: 8px 10px;
		background-color: rgba(35, 82, 162, 0.12);
		box-shadow: inset 0 2px 3px var(--color-box-shadow-2);
		border-radius: 13px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;

		.warning-icon {
			margin-right: 12px;
			width: 25px;
			height: 25px;

			:deep(svg) {
				width: 100%;
				height: 100%;

				.fill {
					fill: $primary;
				}
			}
		}

		.warning-info {
			width: calc(100% - 37px);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;

			.warning-body {
				font-size: 14px;
				color: var(--color-txt);
			}
		}
	}

	.attachment-dropzone {
		width: 100%;

		:deep(.dropzone-container) {
			width: 100%;
		}
	}
}
</style>